import { useState } from 'react';
import pharmacy from 'services/pharmacy';
import { useHistory } from 'react-router-dom';
import { SET_ERROR_MESSAGE } from 'helpers/types';
import { useDispatch } from 'react-redux';

export default () => {
  const [cards, setCards] = useState([]);
  const [loadingCards, setLoadingCards] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  const getCards = async () => {
    try {
      const responseCards = await pharmacy.get(`/payments/cards`, { headers: { 'api-version': 'v2' } });
      setCards(responseCards.data);
      setLoadingCards(false);
    } catch (e) {
      setLoadingCards(false);
      history.push('/pharmacy/error');
    }
  };

  const postTokenizeCard = async (session) => {
    try {
      const responseTokenize = await pharmacy.post(`/payments/tokenise-card`, {
        payment_session: {
          id: session,
        },
        source_of_funds: {
          type: 'CARD',
        },
      });
      return responseTokenize;
    } catch (e) {
      history.push('/pharmacy/error');
    }
  };

  const deleteCard = async (token) => {
    try {
      await pharmacy.delete(`/payments/cards/${token}`);
    } catch (e) {
      if (e.response && e.response.status === 412 && e.response.data.readable_error_message) {
        throw e.response.data.readable_error_message;
      } else {
        history.push('/pharmacy/error');
      }
    }
  };

  const postSaveCheckoutCard = async (token) => {
    try {
      const responseTokenize = await pharmacy.post(`/payments/tokenise-card`, {
        checkout_token: token,
      });
      return responseTokenize;
    } catch (e) {
      if (e.response?.status === 422) {
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: 'Invalid request was made. It is possible you were trying to add a payment type we do not currently support, please try a different type',
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
      } else if (e.response && e.response.data.readable_error_message) {
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: e.response.data.readable_error_message,
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
      }
      throw e;
    }
  };

  return [cards, loadingCards, getCards, postTokenizeCard, deleteCard, postSaveCheckoutCard];
};
